<template>
  <!-- eslint-disable vue/no-mutating-props -- account is a nested reactive object from parent form state, bound via v-model -->
  <div class="group">
    <div class="field gender">
      <label>{{ $t('gender') }}</label>
      <div>
        <div class="radio-group">
          <label class="radio">
            <input
              type="radio"
              :name="`gender${index}`"
              value="male"
              v-model="account.details.gender"
              autocomplete="sex"
            />
            <span class="label">{{ $t('gender-male') }}</span>
          </label>
          <label class="radio">
            <input
              type="radio"
              :name="`gender${index}`"
              value="female"
              v-model="account.details.gender"
              autocomplete="sex"
            />
            <span class="label">{{ $t('gender-female') }}</span>
          </label>
          <label class="radio">
            <input
              type="radio"
              :name="`gender${index}`"
              value="other"
              v-model="account.details.gender"
              autocomplete="sex"
            />
            <span class="label">{{ $t('gender-other') }}</span>
          </label>
        </div>

        <v-form-error :error="errors[`accounts.${index}.details.gender`]" />
      </div>
    </div>
  </div>

  <div class="group">
    <div class="field date">
      <label>{{ $t('date of birth') }}</label>
      <div>
        <v-dateinput v-model="account.details.birthday" />
        <v-form-error :error="errors[`accounts.${index}.details.birthday`]" />
      </div>
    </div>

    <div class="field">
      <label :for="fieldId('account', index, 'birthplace')">{{ $t('place of birth') }}</label>
      <div>
        <input :id="fieldId('account', index, 'birthplace')" type="text" v-model="account.details.birthplace" />
        <v-form-error :error="errors[`accounts.${index}.details.birthplace`]" />
      </div>
    </div>
  </div>

  <div class="group">
    <div class="field">
      <label :for="fieldId('account', index, 'nationality')">{{ $t('nationality') }}</label>
      <div>
        <select :id="fieldId('account', index, 'nationality')" v-model="account.details.nationality">
          <option v-for="country in nationalities" :key="country.code" :value="country.code">
            {{ country.demonym }}
          </option>
        </select>

        <v-form-error :error="errors[`accounts.${index}.details.nationality`]" />
      </div>
    </div>

    <slot name="after-nationality" />
  </div>
</template>

<script lang="ts" setup>
import { useRegistrationContext } from '/@front:shared/composables/useRegistrationContext'
import type { Account } from '/@front:shared/registration'
import { fieldId } from '/@front:shared/utils'

defineProps<{
  account: Account
  index: number
  errors: Record<string, string>
}>()

const { nationalities } = useRegistrationContext()
</script>
